import { __awaiter, __generator } from "tslib";
var FileDesc /* extends Entity */ = /** @class */ (function () {
    function FileDesc(fileDescRepo) {
        this.fileDescRepo = fileDescRepo;
    }
    FileDesc.prototype.init = function (data) {
        Object.assign(this, data);
    };
    FileDesc.prototype.fetchFileDesc = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileDescRepo.fetchFileDesc(fileId)];
            });
        });
    };
    FileDesc.prototype.getFormattedFileSize = function () {
        var size = this.accurateSize;
        // 这里可能会有 '0' 的情况
        if (Number(size) === 0)
            return '0 B';
        var standard = 1024;
        var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(size) / Math.log(standard));
        // 保留两位小数
        return "".concat(parseFloat((size / Math.pow(standard, i)).toPrecision(3)), " ").concat(units[i]);
    };
    return FileDesc;
}());
export { FileDesc };
